<template>
  <div class="success-page">
    <!-- 图片加载完成后显示 -->
    <img :src="imageSrc" alt="录取通知书" v-if="imageSrc" class="responsive-image" @load="handleImageLoaded" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { ElLoading } from 'element-plus';

export default {
  name: 'SuccessPage',
  setup() {
    const studentName = ref('');
    const imageSrc = ref(null);
    let loadingInstance = null; // 用于存放loading实例
    const router = useRouter();

    onMounted(async () => {
      const name = localStorage.getItem('admittedStudentName');
      localStorage.removeItem('admittedStudentName');

      if (name) {
        studentName.value = name;
        // 显示加载指示器
        loadingInstance = ElLoading.service({
          lock: true,
          text: '当前生成人数较多，通知书正在生成中...',
          background: 'rgba(0, 0, 0, 0.7)',
        });

        try {
          // 在这里添加API密钥到请求头
          const config = {
              headers: {
                'X-API-Key': 'Pa44w0rd!@#$', // 确保这里的引号是正确的
              },
              responseType: 'blob',
            };

          const response = await axios.post('/generate-image', { studentName: name }, config);
          imageSrc.value = URL.createObjectURL(response.data);
        } catch (error) {
          console.error("图片生成失败:", error);
        } finally {
          if (loadingInstance) {
            loadingInstance.close(); // 确保在请求完成后关闭加载指示器
          }
        }
      } else {
        router.push('/');
      }
    });

    // 图片加载完成时调用
    const handleImageLoaded = () => {
      if (loadingInstance) {
        loadingInstance.close(); // 关闭加载指示器
      }
    };

    const goHome = () => {
      router.push('/');
    };

    return {
      studentName,
      imageSrc,
      goHome,
      handleImageLoaded,
    };
  },
};
</script>

<style scoped>
/* 添加样式以使图片自动缩放 */
.responsive-image {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}
</style>